import React, { useState, useEffect } from "react";

const TextArea = ({
  input,
  inputValues,
  setInputValues
  }) => {
  const [val, setVal] = useState(input.value? input.value : "");

  const handleOnChange = (value, input) => {
    setVal(value)
    setInputValues(inputValues.filter((ele) => ele.id !== input.id).concat([{ id: input.id, value: value}]))
  }

  return (
    <div className="group-form">
      <textarea className="form-control" value={val} onChange={(e) => handleOnChange(e.target.value, input)}/>
    </div>
  );
};

export default TextArea;